import { render, staticRenderFns } from "./Attendance.vue?vue&type=template&id=b606d984&scoped=true"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"
import style0 from "./Attendance.vue?vue&type=style&index=0&id=b606d984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b606d984",
  null
  
)

export default component.exports